export default "__VITE_ASSET__C4RrpH9B__"